module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-field"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Field")]), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("基础用法")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-field', {
    attrs: {
      "type": "text",
      "label": "用户名：",
      "placeholder": "请输入用户名"
    }
  }), _vm._v(" "), _c('zan-field', {
    attrs: {
      "type": "password",
      "label": "密码：",
      "placeholder": "请输入密码"
    }
  }), _vm._v(" "), _c('zan-field', {
    attrs: {
      "type": "textarea",
      "label": "个人介绍：",
      "placeholder": "请输入个人介绍"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("无label的输入框")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-field', {
    attrs: {
      "type": "text",
      "placeholder": "请输入用户名"
    }
  })], 1), _vm._v(" "), _c('h2', {
    staticClass: "page-sub-title"
  }, [_vm._v("监听change事件")]), _vm._v(" "), _c('zan-cell-group', [_c('zan-field', {
    attrs: {
      "type": "text",
      "label": "用户名：",
      "placeholder": "请输入用户名"
    },
    on: {
      "change": _vm.handleChange
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3804020f!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/examples/field.vue
// module id = 280
// module chunks = 0